module.exports = new __parcel__URL__("train_5_inactive.a7100040.png").toString();